import { Component, EventEmitter, Input, input, Output, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DirectionService } from '../../services/direction.service';
import { SocketService } from '../../services/socket.service';
import { IndicatorsService } from '../../services/indicators.service';
import { TableModule } from 'primeng/table';
import { TranslateModule } from '@ngx-translate/core';
import { TagModule } from 'primeng/tag';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { RouterModule } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { RadioButtonModule } from 'primeng/radiobutton';
import { NotificationTypesEnum } from '../../interfaces';
import { NotificationService } from '../../services/notification.service';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { WebViewerComponent } from '../../webviewer/webviewer.component';
import { SignalRService } from '../../services/signal-r.service';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';

import { NavTitlePipe } from '../../pipes/nav-title.pipe';

@Component({
  selector: 'app-indicator-file-audtior',
  standalone: true,
  imports: [
    NavTitlePipe,
    DialogModule,
    WebViewerComponent,
    CommonModule,
    TableModule,
    FormsModule,
    RadioButtonModule,
    RouterModule,
    TranslateModule,
    TooltipModule,
    TagModule,
    ButtonModule,
    InputTextModule,
    DropdownModule
  ],
  templateUrl: './indicator-file-audtior.component.html',
  styleUrl: './indicator-file-audtior.component.scss'
})
export class IndicatorFileAudtiorComponent {

  @ViewChild('assessmentForm') assessmentForm!: NgForm;
  dir!: 'rtl' | 'ltr';
  @Output() onFileReviewed = new EventEmitter<string>();
  isAuditSubmitted = false;
  assessmentModal = false;
  selectedFile!: any;
  mileStones = [] as any[];
  @Input() strategyId = 0
  @Input() indicatorId = 0
  locale!: "ar" | "en";
  searchQuery: string = '';


  constructor(
    private toastr: ToastrService,
    private directionService: DirectionService,
    private indicatorService: IndicatorsService,
    private notificationService: NotificationService,
    private signalrService: SignalRService

  ) {
  }
  ngOnInit(): void {
    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;
      this.locale = dir == "rtl" ? "ar" : "en";
    })
    this.indicatorService.getIndicatorOutcomesFileAuditor(this.strategyId, this.indicatorId).subscribe((response: any) => {
      this.mileStones = response['data']['outcomes'];
    })

  }





  openAssessmentModal(file: any) {
    this.assessmentModal = true;
    this.selectedFile = { ...file, comments: file.comments.trim() };
  }

  closeAssessmentModal() {
    this.assessmentModal = false;
    this.selectedFile = null;
  }
  getFileIcon(type: string) {
    switch (type) {
      case 'image/jpeg':
      case 'image/png':
        return "fa-solid fa-file-image";
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        return "fa-solid fa-file-word";
      case 'application/pdf':
        return "fa-solid fa-file-pdf";
      case 'video/mp4':
      case 'video/x-msvideo':
      case 'video/quicktime':
      case 'video/x-matroska':
        return "fa-solid fa-file-video";
      default:
        return "fa-solid fa-file";
    }
  }
  assessOutput() {
    this.isAuditSubmitted = true;
    this.indicatorService.reviewAuditFile(this.strategyId, { ... this.selectedFile, fileType: this.selectedFile.entityType }).subscribe((response: any) => {
      this.assessmentModal = false;
      const milestone = this.mileStones.find(x => x.id == this.selectedFile.subEntityId)
      if (milestone) {
        const mappedFiles = milestone.files.map((x: any) => x.id == this.selectedFile.id ? { ...this.selectedFile } : x)
        milestone.files = mappedFiles
        this.mileStones = this.mileStones.map((x: any) => x.id == this.selectedFile.subEntityId ? { ...milestone } : x)
      }
      this.signalrService.reconnectIfDisconnected();
      this.notificationService.pushAuditRequest(
        this.strategyId, {
        id: this.selectedFile.id,
        parentEntityId: this.indicatorId,
        subEntityId: this.selectedFile.subEntityId,
        type: NotificationTypesEnum.outcome_proof_audit_response
      },
        this.locale
      )

      this.onFileReviewed.emit(`${this.selectedFile.file_name} تم تقييم`)






      this.toastr.success(response['data']['message'])
    })
  }

  MediaFileStatusEnum = {
    pending: 'pending',
    approved: 'approved',
    rejected: 'rejected'
  };
  FileStatusValues = {
    pending: "قيد المراجعة",
    approved: "معتمد",
    rejected: "مرفوض"
  };
  isFileViewer = false;
  openFileViewer(file: any) {
    this.selectedFile = file;
    console.log("selected file", this.selectedFile);
    this.isFileViewer = true
  }
  downloadFile(file: any) {
    console.log("selected file", this.selectedFile);
    this.indicatorService.downloadOutcomeProof(this.strategyId, file.indicator_id, file.outcome_id, file.id).subscribe((x) => {
      console.log("blob", x);
      const blob = new Blob([x], { type: x.type });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = "";
      anchor.click();
      window.URL.revokeObjectURL(url);
    });
  }
  
  goBack() {
    window.history.back();
  }
}
